import React from 'react'
import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import { Box, Button } from '../../../../../../components/mui/Core/index'
import { setCurrentStep } from '../../invite-user-modal-slice'
import Constants from '../../../../../../constants/en.json'

function InviteUserNavigation({ handleCloseAction, handleSubmitAction }) {
  const dispatch = useDispatch()
  const selectedRole = useSelector((state) => state.inviteUser.selectedRole)
  const email = useSelector((state) => state.inviteUser.email)
  const selectedOrganization = useSelector((state) => state.inviteUser.selectedOrganization)
  const isInviteConfirmed = useSelector((state) => state.inviteUser.isInviteConfirmed)
  const totalSteps = useSelector((state) => state.inviteUser.totalSteps)
  const currentStep = useSelector((state) => state.inviteUser.currentStep)
  const isLastStep = currentStep === totalSteps

  const isNextActionDisabled = () => {
    switch (currentStep) {
      case 1:
        return !email || !selectedRole
      case 2:
        return !selectedOrganization
      case 3:
        return !isInviteConfirmed
      default:
        return true
    }
  }

  const handleBackAction = () => {
    const previousStep = currentStep - 1 >= 1 ? currentStep - 1 : currentStep
    dispatch(setCurrentStep(previousStep))
  }

  const handleNextAction = () => {
    const nextStep = currentStep + 1 <= totalSteps ? currentStep + 1 : currentStep
    if (!isLastStep) {
      dispatch(setCurrentStep(nextStep))
    }
  }

  const handleCancelAction = () => {
    handleCloseAction()
  }

  const rootStyle = { display: 'flex' }
  const rightButtonGroupStyle = { display: 'flex', width: '100%', justifyContent: 'right' }
  const nextActionButtonContainerStyle = { ml: '8px' }
  const submitActionButtonStyle = { minWidth: '174px' }

  return (
    <Box sx={rootStyle}>
      {currentStep > 1 && (
        <Box>
          <Button color='secondary' variant='outlined' onClick={handleBackAction}>
            {Constants.userManagement.inviteUser.BACK}
          </Button>
        </Box>
      )}
      <Box sx={rightButtonGroupStyle}>
        <Box>
          <Button color='secondary' variant='outlined' onClick={handleCancelAction}>
            {Constants.userManagement.inviteUser.CANCEL}
          </Button>
        </Box>

        <Box sx={nextActionButtonContainerStyle}>
          {!isLastStep && (
            <Button
              disabled={isNextActionDisabled()}
              variant='contained'
              color='secondary'
              onClick={handleNextAction}
            >
              {Constants.userManagement.inviteUser.NEXT}
            </Button>
          )}
          {isLastStep && (
            <Button
              sx={submitActionButtonStyle}
              variant='contained'
              color='secondary'
              onClick={handleSubmitAction}
              disabled={isNextActionDisabled()}
            >
              {Constants.userManagement.inviteUser.SEND_INVITE.toUpperCase()}
            </Button>
          )}
        </Box>
      </Box>
    </Box>
  )
}

InviteUserNavigation.propTypes = {
  handleCloseAction: PropTypes.func,
  handleSubmitAction: PropTypes.func,
}

export default InviteUserNavigation
